import index from '@/pages/activity/index.vue'
export default {
  path: '/activity',
  name: 'activity',
  component: index,
  redirect: '/activity/index',
  meta: {
    title: '禾蛙活动专区',
  },
  children: [
    {
      path: 'index',
      name: 'index',
      component: () =>
        import(
          /* webpackChunkName: "activity" */ '@/pages/activity/components/activity.vue'
        ),
      meta: {
        title: '禾蛙活动专区',
      },
    },
    {
      path: 'preach',
      name: 'preach',
      component: () =>
        import(
          /* webpackChunkName: "preach" */ '@/pages/activity/components/preach.vue'
        ),
      meta: {
        title: '职位宣讲',
      },
    },
  ],
}
